import { render, staticRenderFns } from "./firstLetter.vue?vue&type=template&id=771cfc6e&scoped=true"
import script from "./firstLetter.vue?vue&type=script&lang=js"
export * from "./firstLetter.vue?vue&type=script&lang=js"
import style0 from "./firstLetter.vue?vue&type=style&index=0&id=771cfc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771cfc6e",
  null
  
)

export default component.exports